import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{  }>;

export const DispatchSpcPoNumber: HandlerType = props => {
    props.dispatch({
        type: "Custom/SpcPONumber/SpcPONumberError",
        SpcPONumberError: "PO Number is required",
    });

    props.dispatch({
        type: "Custom/SpcPONumber/SpcshowFormErrors",
        SpcshowFormErrors: true,
    });
};

export const chain = [DispatchSpcPoNumber];

const CenSPCPONumberErrorHandler = createHandlerChainRunner(chain, "CenSPCPONumberErrorHandler");
export default CenSPCPONumberErrorHandler;
